module.exports = __webpack_public_path__ + "img/location.c3aa1f15.svg";